/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Valve } from "./modelValve";

class ControllerValve extends ControllerModel {
  constructor() {
    super("ControllerValve");
    
    this.setNewNode = (callback) => {
      let valve = new Valve();
      valve.decorate(callback);

      this.addNode(valve);
    }

    this.loadNode = (node, callback) => {
      let valve = new Valve();
      valve.copyFrom(node);
      valve.decorate(callback);
      this.addNode(valve)
    }

    this.getProperties = async (node) => {
      let n = new Valve();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new Valve();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerValve };
